import { useEffect, useState } from "react";
import { getSubscriptionStats } from "services/subscription-stats-service";

const INCLUSIVE_SPAN_DAYS = 400;
const REPORT_TIME_ZONE = "America/Los_Angeles";

const partValue = (parts, type) => {
	const part = parts.find((item) => item.type === type);
	if (!part) {
		throw new Error("Missing Pacific date part");
	}
	return part.value;
};

const pacificToday = () => {
	const parts = new Intl.DateTimeFormat("en-US", {
		timeZone: REPORT_TIME_ZONE,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	}).formatToParts(new Date());
	return `${partValue(parts, "year")}-${partValue(parts, "month")}-${partValue(parts, "day")}`;
};

const shiftIsoDate = (isoDate, dayDelta) => {
	const [year, month, day] = isoDate.split("-").map((value) => Number(value));
	const utc = new Date(Date.UTC(year, month - 1, day));
	utc.setUTCDate(utc.getUTCDate() + dayDelta);
	return utc.toISOString().slice(0, 10);
};

export const useSubscriptionStats = () => {
	const [stats, setStats] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let active = true;

		const fetchStats = async () => {
			try {
				const to = pacificToday();
				const from = shiftIsoDate(to, -(INCLUSIVE_SPAN_DAYS - 1));
				const data = await getSubscriptionStats(from, to);
				if (active) {
					setStats(data);
				}
			} catch (err) {
				if (active) {
					setError(err instanceof Error ? err.message : "Error loading subscription stats");
				}
			} finally {
				if (active) {
					setLoading(false);
				}
			}
		};

		fetchStats();
		return () => {
			active = false;
		};
	}, []);

	return { stats, loading, error };
};
